export const EASING = {
  smooth: [0.16, 1, 0.3, 1],
  standard: [0.4, 0, 0.2, 1],
  emphasize: [0.22, 1, 0.36, 1],
};

export const DURATION = {
  hover: 0.19,
  press: 0.14,
  sectionReveal: 0.58,
  heroEntrance: 0.9,
  pageTransition: 0.28,
  scoreReveal: 1.4,
};

export const STAGGER = {
  heading: 0.06,
  copy: 0.1,
  card: 0.13,
  chart: 0.16,
};

export const VARIANTS = {
  fadeUp: {
    hidden: { opacity: 0, y: 24 },
    show: {
      opacity: 1,
      y: 0,
      transition: { duration: DURATION.sectionReveal, ease: EASING.smooth },
    },
  },
  fade: {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { duration: DURATION.sectionReveal, ease: EASING.standard },
    },
  },
  page: {
    initial: { opacity: 0, y: 8 },
    animate: {
      opacity: 1,
      y: 0,
      transition: { duration: DURATION.pageTransition, ease: EASING.standard },
    },
    exit: {
      opacity: 0,
      y: -8,
      transition: { duration: DURATION.pageTransition, ease: EASING.standard },
    },
  },
};

export const SPRING = {
  soft: { type: "spring", stiffness: 210, damping: 22, mass: 0.7 },
  medium: { type: "spring", stiffness: 270, damping: 24, mass: 0.65 },
  score: { type: "spring", stiffness: 180, damping: 20, mass: 0.8 },
};

export function isTouchDevice() {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(pointer: coarse)").matches;
}
